$(document).ready(function(){
    $(document).on('click', '.cl-po--swatch-button' , function() {
        setTimeout(function(){
            $(".cl-po--radio-item").find('span').each(function() {
                // Create a new button element
                var data_id = $(this).attr('data-id');
                var className = $(this).attr('class');

                var button = $("<button class='"+className+"' data-id='"+data_id+"'>");
                // Replace the span with the button
                $(this).replaceWith(button);
            });
        }, 500);


        setTimeout(function(){
            $(".cl-po--checkbox-item").find('span').each(function() {
                // Create a new button element
                var data_id = $(this).attr('data-id');
                var className = $(this).attr('class');

                var button = $("<button class='"+className+"' data-id='"+data_id+"'>");
                // Replace the span with the button
                $(this).replaceWith(button);
            });
        }, 500);
    });
//cookies popup
    window.addEventListener('scroll', function() {
        var bannerWrapper = document.getElementById('banner-wrapper');
        var displayPopup = document.getElementById('displayPopup');
        if (window.scrollY > 200) {
            if (bannerWrapper) {
                var inlineStyles = bannerWrapper.getAttribute('style');
                //console.log(inlineStyles);
                if (inlineStyles && displayPopup) {
                    displayPopup.style.display = 'block';
                }
            }
        }
    });
    // back to top button
    setTimeout(function () {
        var headerHeight = $("header.shopify-section--header").outerHeight();
        var footerHeight = $("footer.shopify-section--footer").outerHeight();
        var totalHeight = $(document).height();
        var contentHeight = totalHeight - headerHeight - footerHeight;
        if (contentHeight > 1300) {
            $(window).scroll(function () {
                if ($(this).scrollTop() > 500) {
                    $(".top_button").fadeIn(500);
                } else {
                    $(".top_button").fadeOut(500);
                }
            });
            $(".top_button").click(function (event) {
                event.preventDefault();
                $("html, body").animate(
                    {
                        scrollTop: 0,
                    },
                    400
                );
            });
        }
    }, 2000);


// newsletter js
window.addEventListener("load", function () {
    var currentUrl = window.location.href;
    var popupElement = document.querySelector(".custom-model-newsletter");

    // Check if the current page is the challenge page
    if (currentUrl.includes("https://la-melle.de/challenge")) {
        return; // Do nothing if it's the challenge page
    }

    // Check if URL contains ?customer_posted=true#contact_form
    if (currentUrl.includes("?customer_posted=true#contact_form")) {
        setTimeout(function () {
            popupElement.classList.add("model-open");
            document
                .querySelectorAll(".close-btn, .bg-overlay")
                .forEach(function (element) {
                    element.addEventListener("click", function () {
                        popupElement.classList.remove("model-open");
                    });
                });
        }, 1000); // Show popup after 1 second
    } else {
        setTimeout(function () {
            var popupShownOnce = localStorage.getItem("popupShown");

            if (popupElement.classList.contains("hide-popup")) {
                return;
            }
            if (popupElement.classList.contains("onceTime") && !popupShownOnce) {
                popupElement.classList.add("model-open");
                localStorage.setItem("popupShown", "true");
            }
            if (popupElement.classList.contains("multipleTime")) {
                popupElement.classList.add("model-open");
            }

            document
                .querySelectorAll(".close-btn, .bg-overlay")
                .forEach(function (element) {
                    element.addEventListener("click", function () {
                        popupElement.classList.remove("model-open");
                    });
                });
        }, 5000); // Show popup after 7 seconds
    }
});
document.addEventListener('click', function(e) {
    var target = e.target;
    if (target.matches('button.my-add-to-cart-btn.w-full.big-button-yellow.heading-4')) {
        e.preventDefault();
        // Test: Simuliere Klick auf das eigentliche LPO-Input:
        var lpoInput = document.querySelector('[name="properties[_JETZT GESTALTEN]"]');
        if(lpoInput) {
            lpoInput.click();
        } else {
            // Fallback, damit du siehst, ob du das richtige Element erwischt
            alert('LPO-Input nicht gefunden!');
        }
    }
});
});



